<div class="bread-crumb">
  <ol>
    <li><a routerLink="/">Home</a></li>
    <li *ngFor="let breadcrumb of breadcrumbs; let i = index">
      <a *ngIf="i < breadcrumbs.length - 1" [routerLink]="getBreadcrumbLink(i)"
        [innerHTML]="getCategoryName(breadcrumb) | titlecase"></a>
      <!-- <span *ngIf="i === breadcrumbs.length - 1" [innerHTML]="breadcrumb"></span> -->
    </li>
  </ol>
</div>